export enum MIDDLE_MILE_COLUMN_NAME {
  PARCEL_CENTER_LOCATION_NAME = "parcelCenterLocationName",
  CLIENT_NAME = "clientName",
  EXTERNAL_PARTNER_REGION = "externalPartnerRegion",
  TRACKING_TYPE = "trackingType",
  EXPECTED_ARRIVAL = "expectedArrival",
  TRACKING_NUMBER = "trackingNumber",
  PACKAGES_COUNT = "packagesCount",
  CONTAINER_RECEIVED = "containerReceived",
  RECEIVING_STARTED = "receivingStarted",
  RECEIVING_ENDED = "receivingEnded",
  NOTES = "notes",
}

export enum MIDDLE_MILE_LABEL_NAME {
  PARCEL_CENTER_LOCATION_NAME = "Parcel Center",
  CLIENT_NAME = "Client",
  EXTERNAL_PARTNER_REGION = "External Partner Region",
  TRACKING_TYPE = "Tracking Type",
  EXPECTED_ARRIVAL = "Expected Arrival",
  TRACKING_NUMBER = "Tracking Number",
  PACKAGES_COUNT = "Packages Count",
  CONTAINER_RECEIVED = "Container Received Time",
  RECEIVING_STARTED = "Sort Start Time",
  RECEIVING_ENDED = "Sort End Time",
  NOTES = "Notes",
}

export const MIDDLE_MILE_FILTER_COLUMN_OPTIONS = [
  {
    label: MIDDLE_MILE_LABEL_NAME.PARCEL_CENTER_LOCATION_NAME,
    value: MIDDLE_MILE_COLUMN_NAME.PARCEL_CENTER_LOCATION_NAME,
  },
  {
    label: MIDDLE_MILE_LABEL_NAME.CLIENT_NAME,
    value: MIDDLE_MILE_COLUMN_NAME.CLIENT_NAME,
  },
  {
    label: MIDDLE_MILE_LABEL_NAME.EXTERNAL_PARTNER_REGION,
    value: MIDDLE_MILE_COLUMN_NAME.EXTERNAL_PARTNER_REGION,
  },
  {
    label: MIDDLE_MILE_LABEL_NAME.TRACKING_TYPE,
    value: MIDDLE_MILE_COLUMN_NAME.TRACKING_TYPE,
  },
  {
    label: MIDDLE_MILE_LABEL_NAME.EXPECTED_ARRIVAL,
    value: MIDDLE_MILE_COLUMN_NAME.EXPECTED_ARRIVAL,
  },
  {
    label: MIDDLE_MILE_LABEL_NAME.TRACKING_NUMBER,
    value: MIDDLE_MILE_COLUMN_NAME.TRACKING_NUMBER,
  },
  {
    label: MIDDLE_MILE_LABEL_NAME.PACKAGES_COUNT,
    value: MIDDLE_MILE_COLUMN_NAME.PACKAGES_COUNT,
  },
  {
    label: MIDDLE_MILE_LABEL_NAME.CONTAINER_RECEIVED,
    value: MIDDLE_MILE_COLUMN_NAME.CONTAINER_RECEIVED,
  },
  {
    label: MIDDLE_MILE_LABEL_NAME.RECEIVING_STARTED,
    value: MIDDLE_MILE_COLUMN_NAME.RECEIVING_STARTED,
  },
  {
    label: MIDDLE_MILE_LABEL_NAME.RECEIVING_ENDED,
    value: MIDDLE_MILE_COLUMN_NAME.RECEIVING_ENDED,
  },
];
